export const AUTH0_DOMAIN = process.env.REACT_APP_AUTH0_DOMAIN ?? "futureplc.eu.auth0.com"
export const AUTH0_AUDIENCE = process.env.REACT_APP_AUTH0_AUDIENCE ?? "https://adviser.main.prod.sse-prod-eks-euw1.futureplc.engineering/"
export const AUTH0_CLIENT_ID = process.env.REACT_APP_AUTH0_CLIENT_ID ?? "cuT3XNrIQCZ5poLxWN7x57hdQ9AVBc2T"
export const ENABLED_BRANDS = process.env.REACT_APP_BRANDS ?? ""

export const BotIsa = "isa"
export const BotHammer = "hammer"
export const BotSegment = "segment"
export const BOTNAME = process.env.REACT_APP_BOTNAME ?? BotIsa

export const SPONSOR_TRIGGER = "^^*^^"
export const SponsorHermes = "hermes"
export const SponsorNetAPorter = "netaporter"

export const BrandMango = "mango"
